const { default: API } = require("../api/API");

function loginUser({ data, url }) {
  return new Promise(() => {
    API.post("login", data).then(({ data: { data } }) => {
      try {
        localStorage.setItem("rizevo_login_data", JSON.stringify({
          data: {
            token: data.token,
            account_type: data.account_type
          }
        }));
      } catch (ee) {}
      window.location.href = url || "/personal/#/appointments";
    });
  });
}

export default loginUser;
